/* eslint-disable no-unused-vars */


<template>
      <div class="fixed inset-x-0 bottom-0 px-4 pb-4 z-90 sm:inset-0 sm:flex sm:items-center sm:justify-center">
        <!--
            Background overlay, show/hide based on modal state.

            Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
            Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!--
            Modal panel, show/hide based on modal state.

            Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
            Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
        <div class="relative px-4 pt-5 pb-4 overflow-hidden transition-all transform bg-white rounded-lg shadow-xl sm:max-w-lg sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div class="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
            <button @click="close" type="button" class="text-gray-400 transition duration-150 ease-in-out hover:text-gray-500 focus:outline-none focus:text-gray-500" aria-label="Close">
                <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
            </button>
            </div>
            <div class="sm:flex sm:items-start">

            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-headline">
                    Stampa QR - <span class="text-sm font-medium">{{currentlocation.name}}</span>
                </h3>

                <div class="flex flex-wrap">
                    <div class="w-1/3" >
                        <div >
                            <canvas id="canvas"></canvas>
                        </div>
                    </div>
                    <div class="w-2/3">
                        <p class="mt-4 text-sm leading-5 text-gray-700">
                            Scegli il formato <span class="font-semibold text-indigo-700">più adatto</span> alle dimensioni del tuo espositore
                        </p>

                        <select v-model="selectedFormat" class="block w-full mt-4 transition duration-150 ease-in-out form-select sm:text-sm sm:leading-5">
                            <option v-for="format in formats" v-bind:value="format.value" :key="format.value">
                                {{ format.name }}
                            </option>
                        </select>
                        
                    </div>
                </div>
                <p class="text-sm leading-5 text-gray-700">
                        Oppure apri direttammente il menu
                        </p>
                        <p><a target="_blank" class="text-sm font-bold text-indigo-700" :href="'https://apri.menubyte.it/' + this.currentlocation.uuid">https://apri.menubyte.it/{{this.currentlocation.uuid}}</a></p>
            </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                <button @click="generatePdf"  type="button" class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-white bg-green-400 border rounded-md shadow-sm border-gray-50 hover:text-gray-50 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 hover:bg-green-500 focus:border-green-400 focus:shadow-outline-green">
                Scarica PDF
                </button>
            </span>
                <span class="flex w-full mt-3 rounded-md shadow-sm sm:mt-0 sm:w-auto">
                <button @click="close" type="button" class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
                Annulla
                </button>
            </span>
            </div>
        </div>
        </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import QRCode from 'qrcode'
import jsPDF from 'jspdf' 

export default {
    name: 'ModalQr',
    props: {
        currentlocation:{
            type: Object,
            required: true
        },
        eventclose:{
            type: String,
            default: ''
        },
    },
    data() {
        return {
            formats:[
                {
                    value: 1,
                    name: "1 QR per foglio (espositore A4)",
                    npages: 1
                },
                {
                    value: 2,
                    name: "2 QR per foglio (espositore A5)",
                    npages: 2
                },
                {
                    value: 3,
                    name: "4 QR per foglio (espositore A6)",
                    npages: 4
                }
            ],
            selectedFormat : 2,
            pdf:{
                enableEn:true,
                positionY:0,
                lineSpacing:1.5,
                fontSizeTitle:30,
                fontSizeDesc:20,
                fontSizePowerd:20,
                baseFontSizeTitle:30,
                baseFontSizeDesc:20,
                baseFontSizePowerd:20,
                marginX:0,
                marginY:0,
                qrSize:80,
                qRMarginQrTop: 10,
                baseQqRMarginQrTop: 10,
                baseQrSize:80,
                menubyteLogoX: 5,
                menubyteLogoY: 20,
                spaceBetweenLang: 5,
                baseSpaceBetweenLang: 5

            }
        }
    },
    methods: {
        generatePdf: function(){

             /*
            doc.addHTML(document.body,function() {
                pdf.output('datauri');
            });
            */

            var doc = null;
            let pageHeight = 0;
            let pageWidth = 0;
            let maxw = 0;
            let centerGravityX = 0;

            if(this.selectedFormat == 1){
                doc = new jsPDF();
                this.setDimensions(1);

                pageHeight = doc.internal.pageSize.height;
                pageWidth = doc.internal.pageSize.width;
                maxw = pageWidth * 0.8;
                centerGravityX = 105;
                
            }

            if(this.selectedFormat == 2){
                doc = new jsPDF('landscape');
                this.setDimensions(0.75);

                pageHeight = doc.internal.pageSize.height;
                pageWidth = doc.internal.pageSize.width / 2;
                maxw = pageWidth * 0.8;
                centerGravityX = 74.25;

                doc.setLineWidth(0.1);
                doc.setDrawColor(192, 192, 192);

                doc.setLineDash([3]);
                doc.line(148.5, 0 , 148.5, 210);
            }

            if(this.selectedFormat == 3){
                doc = new jsPDF();
                this.setDimensions(0.5);

                pageHeight = doc.internal.pageSize.height / 2;
                pageWidth = doc.internal.pageSize.width / 2;
                maxw = pageWidth * 0.8;
                centerGravityX = 52.5;
                
                doc.setLineWidth(0.1);
                doc.setDrawColor(192, 192, 192);

                doc.setLineDash([3]);
                doc.line(105, 0 , 105, 297);
                doc.line(0, 148.5 , 210, 148.5);

            }


            let line1It = "Scopri il nostro menu";
            let line2It = "Inquadra con il tuo smartphone il QR qui sotto";

            let line1En = "Discover our menu";
            let line2En = "Scan the QR below with your phone";

           
            doc.setFontSize(this.pdf.fontSizeTitle);
            doc.setFont(this.pdf.font1);
            let textLines1It = doc.splitTextToSize(line1It, maxw);
            let textLines1En = doc.splitTextToSize(line1En, maxw);
 
            doc.setFontSize(this.pdf.fontSizeDesc);
            doc.setFont(this.pdf.font1);
            let textLines2It = doc.splitTextToSize(line2It, maxw);
            let textLines2En = doc.splitTextToSize(line2En, maxw);


            let deltaYTextLine1 = this.pdf.fontSizeTitle * this.pdf.lineSpacing * 25.4/72; 
            let deltaYTextLine2 = this.pdf.fontSizeDesc * this.pdf.lineSpacing * 25.4/72; 
            
            let totalH = 0;
            if(this.pdf.enableEn){
                totalH = (textLines1It.length + textLines1En.length) * deltaYTextLine1 + (textLines2It.length + textLines2En.length) * deltaYTextLine2 + this.pdf.qrSize + this.pdf.qRMarginQrTop + deltaYTextLine1 + this.pdf.spaceBetweenLang;
            }else{
                totalH = (textLines1It.length) * deltaYTextLine1 + (textLines2It.length ) * deltaYTextLine2 + this.pdf.qrSize + this.pdf.qRMarginQrTop + deltaYTextLine1;
            }

            this.pdf.marginY = (pageHeight - totalH) / 2;

            let r = this.formats.filter(x => x.value == this.selectedFormat);

            let imgData = this.getURI();
            for(let i=0; i< r[0].npages; i++){
                if(i == 0){
                    this.pdf.positionY = this.pdf.marginY;
                }

                if(i == 1){
                    this.pdf.positionY = this.pdf.marginY;
                    centerGravityX = centerGravityX * 3;
                }

                if(i == 2){
                    this.pdf.positionY = pageHeight + this.pdf.marginY;
                    centerGravityX = centerGravityX / 3;
                }

                if(i == 3){
                    this.pdf.positionY = pageHeight  + this.pdf.marginY;
                    centerGravityX = centerGravityX * 3;
                }

 
                doc.setFont(this.pdf.font1);
                doc.setFontSize(this.pdf.fontSizeTitle);
                textLines1It.forEach(lineText => {
                    this.pdf.positionY += deltaYTextLine1;
                    doc.text(lineText, centerGravityX, this.pdf.positionY, null, null, "center");
                });

                doc.setFont(this.pdf.font1);
                doc.setFontSize(this.pdf.fontSizeDesc);
                textLines2It.forEach(lineText => {
                    this.pdf.positionY += deltaYTextLine2;
                    doc.text(lineText, centerGravityX, this.pdf.positionY, null, null, "center");
                });

                if(this.pdf.enableEn){
                    doc.setFont(this.pdf.font1);
                    doc.setFontSize(this.pdf.fontSizeTitle);
                    textLines1En.forEach(lineText => {
                        this.pdf.positionY += deltaYTextLine1 + this.pdf.spaceBetweenLang;
                        doc.text(lineText, centerGravityX, this.pdf.positionY, null, null, "center");
                    });

                    doc.setFont(this.pdf.font1);
                    doc.setFontSize(this.pdf.fontSizeDesc);
                    textLines2En.forEach(lineText => {
                        this.pdf.positionY += deltaYTextLine2;
                        doc.text(lineText, centerGravityX, this.pdf.positionY, null, null, "center");
                    });
                }

                doc.addImage(imgData, "JPEG", centerGravityX - this.pdf.qrSize/2, this.pdf.positionY + this.pdf.qRMarginQrTop, this.pdf.qrSize, this.pdf.qrSize);
            
                if (i == 0 || i == 1){
                    doc.text("Powerd by menubyte.it", centerGravityX, pageHeight - deltaYTextLine1, null, null, "center");
                }else{
                    doc.text("Powerd by menubyte.it", centerGravityX, pageHeight*2 - deltaYTextLine1, null, null, "center");
                }
            }

            
            
            
           
            doc.save("menubyte-QR-" + this.currentlocation.name + ".pdf");
        },

        setDimensions: function(perc){
            this.pdf.fontSizeTitle = this.pdf.baseFontSizeTitle * perc;
            this.pdf.fontSizeDesc = this.pdf.baseFontSizeDesc * perc;
            this.pdf.fontSizePowerd = this.pdf.baseFontSizePowerd * perc;
            this.pdf.qrSize = this.pdf.baseQrSize * perc;
            this.pdf.qRMarginQrTop = this.pdf.baseQqRMarginQrTop * perc;
            this.pdf.spaceBetweenLang = this.pdf.baseSpaceBetweenLang * perc;
        },

        getURI: function(){
        var canvas = document.getElementById("canvas");
        return canvas.toDataURL("image/jpeg");
        },

        close: function() {
            this.$root.$emit(this.eventclose)
        },
        
    },
    mounted:function(){
        QRCode.toCanvas(document.getElementById("canvas"), "https://apri.menubyte.it/"+this.currentlocation.uuid, function (error) {
            if (error) console.error(error)
        })
    }
}
</script>

<style scoped>
#canvas{
    max-width: 100%;
    height: auto !important;
}
</style>
